import { Component, OnInit, ViewChild } from '@angular/core';
import { FastAPIService } from '../../service/fast-api.service';
import { first, filter, lastValueFrom, timeInterval } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ConfirmationService, MessageService, TreeNode, TreeTableNode, PrimeIcons } from 'primeng/api';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { FileUpload } from 'primeng/fileupload';
@Component({
  selector: 'app-geocode',
  templateUrl: './geocode.component.html',
  styleUrls: ['./geocode.component.scss']
})
export class GeocodeComponent {
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  background = "assets/web-scraping-component-images/background.svg";
  mainIcon = "assets/web-scraping-component-images/mainIcon.svg";
  deleteBtnIcon = "assets/web-scraping-component-images/delete.svg";
  createBtnIcon = "assets/web-scraping-component-images/add.svg";
  orderIcon = "assets/web-scraping-component-images/order.svg";
  upIcon = "assets/web-scraping-component-images/up.svg";
  downIcon = "assets/web-scraping-component-images/down.svg";
  viewBtnIcon = "assets/web-scraping-component-images/view.svg";
  viewBtnActiveIcon = "assets/web-scraping-component-images/viewActive.svg";
  checkBtnIcon = "assets/web-scraping-component-images/savePending.svg";
  checkBtnActiveIcon = "assets/web-scraping-component-images/checkActive.svg";
  toBeginningIcon = "assets/web-scraping-component-images/start.svg";
  nextIcon = "assets/web-scraping-component-images/next.svg";
  backIcon = "assets/web-scraping-component-images/back.svg";
  toLastIcon = "assets/web-scraping-component-images/last.svg";
  calenderIcon = "assets/web-scraping-component-images/calendar.svg";
  loadingIcon = "assets/web-scraping-component-images/loading.svg";
  fetchIcon = "assets/web-scraping-component-images/fetchIcon.svg";
  arrowRight = "assets/web-scraping-component-images/Arrow - Right 3.svg"
  restartIcon = "assets/web-scraping-component-images/restartBtn.svg"


  filterName: string = "";
  filterStartDate: string = "";
  filterEndDate: string = "";
  scriptStartPage: FormControl = new FormControl();
  scriptStopPage: FormControl = new FormControl();

  select_all: boolean = false;
  dialog_visible: boolean = false;
  goto_dialog_visible: boolean = false;
  reverseId: boolean = false;
  reverseDate: boolean = false;
  reverseQuantity: boolean = false;
  requireAuthentication: boolean = false;

  pageSize: number = 10;
  currentPage: number = 1;
  totalRecordAppend: number = 0;
  totalRecordReplace: number = 0;
  gotoPage: number = this.currentPage;

  todayDate: Date = new Date();

  requestReplaceList: GeocodeRequest[] = [];
  requestAppendList: GeocodeRequest[] = [];
  allRequestList: any[] = [];
  filteredList: any[] = [];
  isFiltered: boolean = false;
  isAppend: boolean = false;

  pageSizeList: number[] = [10, 15, 20];

  sortBy: string = 'Filename';
  sortOrder: string = 'desc';
  dialogAction: 'import' | 'reset' | 'upload' = 'import';  // default value

  loading: boolean = false;

  constructor(private fastService: FastAPIService, private messageService: MessageService, private confirmationService: ConfirmationService, private route: Router) {
    // setInterval(() => { this.reload() }, 10000);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;

    this.todayDate = new Date();

    this.scriptStartPage.valueChanges.subscribe((value: number) => {
      let stop: number = this.scriptStopPage.value;

      if (stop < value) stop = value;
      if (stop > value + 10) stop = value + 10;

      this.scriptStopPage.setValue(stop);
    })

  }

  reload() {
    this.getRequestList();
  }

  gettingRequest: Boolean = false;
  async getRequestList() {

    if (this.gettingRequest) return;
    this.gettingRequest = true
    this.requestReplaceList = [];
    this.requestAppendList = [];
    this.allRequestList = []

    const response_replace = await lastValueFrom(this.fastService.getGeocodeList("REPLACE", Math.max(this.getRequestBegin(), 0), this.pageSize, this.sortBy, this.sortOrder));
    const response_append = await lastValueFrom(this.fastService.getGeocodeList("APPEND", Math.max(this.getRequestBegin(), 0), this.pageSize, this.sortBy, this.sortOrder));

    if (response_replace.status_code == 404) return;
    if (response_append.status_code == 404) return;

    this.requestReplaceList = response_replace.response.data
    this.requestAppendList = response_append.response.data || []
    this.totalRecordAppend = response_append.response.total || 1
    this.totalRecordReplace = response_append.response.total || 1
    try {
      const res = await lastValueFrom(this.fastService.getGeocodeList("APPEND", 0, this.totalRecordAppend, this.sortBy, this.sortOrder));

      if (res?.response?.data) {
        this.allRequestList = res.response.data;

      } else {
        this.allRequestList = [];
        console.warn('No data received from getGeocodeList');
      }
    } catch (error) {
      this.allRequestList = [];
      console.error('Error fetching geocode list:', error);
    }

    if (this.isFiltered) {
      this.onApplyClick();
    } else {
      this.updateRequestList();
    }
    this.gettingRequest = false;
  }

  onClearClick() {
    this.filterName = "";
    this.filterStartDate = "";
    this.filterEndDate = "";
    this.isFiltered = false;
    this.filteredList = [];
  }

  async onApplyClick() {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;

    this.currentPage = 1;

    this.filteredList = [...this.allRequestList];

    if (this.filterName != "") {
      this.filteredList = this.filteredList.filter((request) => {
        return request.Filename == this.filterName;
      });
    }

    if (this.filterStartDate != "") {
      this.filteredList = this.filteredList.filter((request) => {
        return new Date(request.Date).getTime() >= new Date(this.filterStartDate).getTime();
      });
    }

    if (this.filterEndDate != "") {
      this.filteredList = this.filteredList.filter((request) => {
        return new Date(request.Date).getTime() <= new Date(this.filterEndDate).getTime() + 86399000;
      });
    }
    this.isFiltered = this.filteredList.length !== this.allRequestList.length;
    this.updateRequestList();
    this.totalRecordAppend = this.filteredList.length
    this.gettingRequest = false;
  }

  onPageSizeChange(event: any) {
    this.currentPage = 1;
    this.updateRequestList()
  }

  getRequestBegin() {
    return Math.min(((this.currentPage - 1) * this.pageSize), this.totalRecordAppend - 1);
  }

  getRequestEnd() {
    return Math.min(this.totalRecordAppend, this.getRequestBegin() + this.pageSize);
  }

  onToBeginningClick() {
    if (!this.totalRecordAppend) return
    this.currentPage = 1;
    this.updateRequestList()
  }

  onNextClick() {
    if (!this.totalRecordAppend) return
    this.currentPage = Math.min(this.currentPage + 1, Math.ceil(this.totalRecordAppend / this.pageSize));
    this.updateRequestList()
  }

  onBackClick() {
    if (!this.totalRecordAppend) return
    this.currentPage = Math.floor(Math.max(1, this.currentPage - 1));
    this.updateRequestList()
  }

  onToLastClick() {
    if (!this.totalRecordAppend) return
    this.currentPage = Math.ceil((this.totalRecordAppend / this.pageSize));
    this.updateRequestList()
  }

  onPageNumberClick() {
    if (!this.totalRecordAppend) return
    this.gotoPage = this.currentPage;
    this.goto_dialog_visible = true;
  }

  onCancelClick() {
    this.dialog_visible = false;
  }

  getGotoOptions() {
    let options: number[] = [];
    for (let i = 1; i <= Math.ceil(this.totalRecordAppend / this.pageSize); i++) {
      options.push(i);
    }
    return options;
  }

  onGotoClick() {
    this.currentPage = this.gotoPage;
    this.goto_dialog_visible = false;
    this.updateRequestList();
  }

  goto(page: number) {
    this.currentPage = page;
    this.updateRequestList();
  }

  isActiveButton(page: number): boolean {
    let length = Math.ceil(this.totalRecordAppend / this.pageSize);

    if (page <= 0 || page > length) {
      return false;
    }

    if (page == this.currentPage - 4) {
      return this.currentPage == length;
    }

    if (page == this.currentPage - 3) {
      return this.currentPage + 1 >= length;
    }

    if (page == this.currentPage + 4) {
      return this.currentPage == 1;
    }

    if (page == this.currentPage + 3) {
      return this.currentPage <= 2;
    }

    return true;
  }
  uploadedFiles: any;
  storeData: any;
  jsonData: any;
  worksheet: any;
  filefields: string[] = [];
  isDocx: boolean = false;
  information: string = "";
  updateReplaceType: string = "REPLACE"
  updateAppendType: string = "APPEND"


  onRemove(event: any) {
    this.uploadedFiles = null;
    this.isDocx = false;
  }

  onSort(event: any) {
    if (this.sortBy !== event.field || this.sortOrder !== (event.order === 1 ? 'asc' : 'desc')) {
      this.sortBy = event.field;
      this.sortOrder = event.order === 1 ? 'asc' : 'desc';
      this.getRequestList();
    }
  }

  updateRequestList() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.requestAppendList = this.isFiltered
      ? this.filteredList.slice(start, end)
      : this.allRequestList.slice(start, end);
  }

  getUpdateTypeClass(updateType: string): string {
    switch (updateType.toUpperCase()) {
      case 'REPLACE': return 'replace';
      case 'APPEND': return 'append';
      default: return '';
    }
  }

  async onDeleteClick(geoId: any) {
    this.confirmationService.confirm({
      message: "Confirm to delete file",
      accept: async () => {
        this.fastService.removeGeocode(geoId._id).subscribe((response: any) => {
          this.messageService.add({ severity: response.status, summary: response.status.toUpperCase(), detail: response.message })
        })
        this.getRequestList();
      }
    })
  }

  onImportClick(action: 'import' | 'reset') {
    this.dialogAction = action;
    this.dialog_visible = true;
    this.requireAuthentication = false;
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
    this.isDocx = false;
    this.information = ""
    this.scriptStartPage.setValue(1);
    this.scriptStopPage.setValue(1);
    this.isAppend = false
  }
  onUploadClick() {
    this.dialogAction = 'upload';
    this.dialog_visible = true;
    this.requireAuthentication = false;
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
    this.isDocx = false;
    this.information = ""
    this.scriptStartPage.setValue(1);
    this.scriptStopPage.setValue(1);
    this.isAppend = true
  }

  onExportClick() {
    this.fastService.getGeocodeDatabaseFile().subscribe((response: Blob) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'geocode-export-file.xlsx';
      a.click();

      window.URL.revokeObjectURL(url);
    });
  }

  onDownloadClick(geoId: any) {
    this.fastService.getGeocodeFile(geoId._id).subscribe((response: Blob) => {
      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = geoId.Filename || 'downloaded_file';
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, error => {
      console.error('Download failed', error);
    });
  }

  onDownloadTemplete() {
    const filePath = 'assets/geocode-images/templete/GeocodeTemplete.xlsx';

    fetch(filePath)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'GeocodeTemplete.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading the file:', error);
      });
  }
  onFileSaveReplaceClick() {
    let data: FormData = new FormData();
    if (this.uploadedFiles) {
      data.append('File', this.uploadedFiles, this.uploadedFiles.name);
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a file' });
      return;
    }
    data.append('UpdateType', this.updateReplaceType)
    if (this.information) {
      data.append('Info', this.information)
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please input information' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Confirm to upload file',
      accept: async () => {
        this.fastService.uploadGeocodeFile(data).subscribe((response: any) => {
          this.messageService.add({ severity: response.status, summary: response.status.toUpperCase(), detail: response.message })
        });
        await this.getRequestList();
        this.isFiltered = false;
        this.onClearClick()
        this.onApplyClick()
        this.currentPage = 1
      }
    })

    this.isAppend = false;
    this.dialog_visible = false;
  }

  onFileSaveAppendClick() {
    let data: FormData = new FormData();
    if (this.uploadedFiles) {
      data.append('File', this.uploadedFiles, this.uploadedFiles.name);
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a file' });
      return;
    }
    if (this.information) {
      data.append('Info', this.information)
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please input information' });
      return;
    }
    data.append('UpdateType', this.updateAppendType)
    this.confirmationService.confirm({
      message: 'Confirm to upload file',
      accept: async () => {
        this.fastService.uploadGeocodeFile(data).subscribe((response: any) => {
          this.messageService.add({ severity: response.status, summary: response.status.toUpperCase(), detail: response.message })
        });
        await this.getRequestList();
        this.isFiltered = false;
        this.onClearClick()
        this.onApplyClick()
        this.currentPage = 1
      }
    })

    this.isAppend = false;
    this.dialog_visible = false;
  }

  uploadHandler(event: any) {
    this.uploadedFiles = event.files[0];
    const fileName: string = this.uploadedFiles.name;
    const fileType = fileName.split('.').pop();
    this.isDocx = fileType == "docx";

    if (this.isDocx) return;

    let readFile = new FileReader();
    readFile.onload = (e) => {
      try {
        this.storeData = readFile.result;
        var data = new Uint8Array(this.storeData);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        this.worksheet = workbook.Sheets[first_sheet_name];
        this.jsonData = XLSX.utils.sheet_to_json(this.worksheet, { raw: false });

        // ตรวจสอบว่าได้ข้อมูลหรือไม่
        if (!this.jsonData || this.jsonData.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: 'Excel file is empty. Please input some data.'
          });
          return;
        }

        this.filefields = Object.keys(this.jsonData[0]);

      } catch (error) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Unable to read Excel file. Please check if the file is valid.'
        });
      }
    }

    readFile.onerror = (error) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Error reading file'
      });
    }

    readFile.readAsArrayBuffer(this.uploadedFiles)
  }
}

export class GeocodeRequest {
  Filename: string = "";
  Date: string = "";
  Information: string = "";
  Quantity: number = 0;
  UpdateType: string = "";
  Action: boolean = true
}